"use client";

import { c as _c } from "react/compiler-runtime";
import { locale as locl } from "@locale";
import cn from "classnames";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./ProgramDateButton.module.css";
import SelectedDateTransition from "src/components/programdatebutton/SelectedDateTransition";
;

//#region [Props]
type ProgramAllDatesButtonProps = {
  className?: string;
  isSelected?: boolean | null;
  onClick?: (showAll: boolean) => void;
  ref?: React.Ref<HTMLButtonElement>;
};
//#endregion

//#region [Component]
export default function ProgramAllDatesButton(t0) {
  const $ = _c(16);
  const {
    className,
    isSelected,
    onClick,
    ref
  } = t0;
  let t1;
  let t2;
  if ($[0] !== className || $[1] !== isSelected || $[2] !== ref) {
    const themeStyles = getThemeStyles(styles, {
      [styles.isSelected]: isSelected
    });
    t1 = ref;
    t2 = cn(styles.ProgramDateButton, styles.AllDaysButton, themeStyles, className);
    $[0] = className;
    $[1] = isSelected;
    $[2] = ref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClick) {
    t3 = onClick ? () => onClick(true) : undefined;
    $[5] = onClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !!isSelected;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.BorderContainer}><div className={cn(styles.AllDays, "AllDays")}>{locl.program.allDates}</div></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isSelected) {
    t6 = <SelectedDateTransition isSelected={isSelected}>{t5}</SelectedDateTransition>;
    $[8] = isSelected;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <button ref={t1} className={t2} onClick={t3} disabled={t4}>{t6}</button>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
//#endregion